module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/сommode-2-31c194781ea15de3d99a1c0666eb33db.svg";